// import Particles from "react-particles-js";
import "./App.css";
import React from "react";
import Navbar from "./components/general/header";
import HomePage from "./components/routes";
import Footer from "./components/general/footer";
import { Provider } from "react-redux";
import { ConfigureStore } from "./components/redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const store = ConfigureStore();
function App() {

  return (
    <Provider store={store}>

      <Navbar />
      <div style={{ marginTop: 56, marginBottom: 200 }}>
        <HomePage />
        
      </div>
      <Footer />
      <ToastContainer />
    </Provider>
  );
}

export default App;
